import React from "react";
import { Button } from "antd";
import { BotView, TopView, Wrapper } from "./TicketScreenCard.styles";

import { Spacer } from "views/components/common/Spacer";
import { formatDatetime } from "lib/date";

import { getTicketCode } from "lib/helpers/ticket";

import { pathOr } from "ramda";

import Info from "views/mobile/components/cards/Info";

import { WizzardButton } from "views/components/WizzardButton";
import { useHistory } from "react-router";

export const TicketScreenCard = ({
	office,
	line,
	ticket,
	dowloadTicketAction,
}) => {
	const history = useHistory();

	const virtualRoom = pathOr(false, ["options", "virtualRoom"], office);
	const meet = pathOr(false, ["meet"], ticket);
	const title = `Tu número de ticket:`;
	const code = (!!ticket && getTicketCode(ticket)) || "N/A";
	const ticketDate =
		!!office && formatDatetime(ticket.inserted_at, office.timezone);

	const handleVirtualRoomRedirect = () => {
		history.push(
			`/waiting-room/${office.slug}/${line.slug}/${ticket.tuid}`
		);
	};

	const type = "ticket";
	return (
		<Wrapper>
			<TopView>
				<Spacer rows={1} />
				<h4 className="officeName">{office.name}</h4>

				<Spacer rows={0.5} />
				<div className={"text-ticket-details"}>
					<span className="line__title">Trámite: </span>
					<p className="line__name">
						{(typeof line === "string" ? line : line.name) ||
							"Sin información"}
					</p>
				</div>
				<Spacer rows={0.5} />
				<p className="date__container">{ticketDate}</p>
				{virtualRoom && meet && (
					<Button
						onClick={handleVirtualRoomRedirect}
						className="virtualRoom__redirect-button"
					>
						Ingresar a la fila virtual
					</Button>
				)}
			</TopView>

			<BotView>
				<Info title={title} body={code} position="left" />
				<WizzardButton
					loading={false}
					type={"backgroundWhite"}
					label="Descargar Ticket"
					onClick={() =>
						dowloadTicketAction(
							line,
							ticket,
							ticketDate,
							type,
							office.name
						)
					}
				/>
			</BotView>
		</Wrapper>
	);
};
